import type {
  ThemeOptions,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants
} from '@mui/material/styles';
import { Theme } from '@ui/ThemeRegistry/theme.types';

const defaultProps: ComponentsProps['Link'] = {};

const styleOverrides: ComponentsOverrides<Theme>['Link'] = {
  root: ({ ownerState, theme }) => ({
    ...(ownerState?.size === 'lg'
      ? {
          ...theme.typography.subtitle1
        }
      : {
          ...theme.typography.subtitle2
        }),
    padding: 'unset',
    display: 'inline-flex',
    textTransform: 'unset',
    alignItems: 'center',
    boxShadow: 'none',

    ...(!!ownerState?.variant
      ? {
          color: 'var(--mui-palette-text-primary, inherit)'
        }
      : {}),

    ...(ownerState?.variant?.includes('Contained') && {
      ...theme.mixins.applyBackgroundColor({ ownerState, theme }),
      'borderRadius': '80px',

      ...(ownerState?.size === 'lg'
        ? {
            padding: '12px 40px'
          }
        : {
            padding: '12px 30px'
          }),

      'border': '0px',
      'backgroundColor': `var(--mui-palette-schemes-${ownerState?.color}-primary-main)`,
      'color': `var(--mui-palette-schemes-${ownerState?.color}-primary-contrastText)`,

      '&:hover': {
        backgroundColor: `var(--mui-palette-schemes-${ownerState?.color}-primary-light)`,
        color: `var(--mui-palette-primary-contrastText)`,
        boxShadow: 'none'
      },

      '&:active': {
        backgroundColor: `var(--mui-palette-schemes-${ownerState?.color}-primary-lighter)`,
        color: `var(--mui-palette-primary-contrastText)`,
        boxShadow: 'none'
      },

      '&.disabled': {
        backgroundColor: `var(--mui-palette-schemes-navyBlue-primary-light)`,
        color: `var(--mui-palette-schemes-white-primary-main)`
      }
    }),

    ...(ownerState?.variant?.includes('Outlined') && {
      ...theme.mixins.applyBackgroundColor({ ownerState, theme }),
      'borderRadius': '80px',
      ...(ownerState?.size === 'lg'
        ? {
            padding: '12px 40px'
          }
        : {
            padding: '10px 28px'
          }),
      'border': '2px solid',
      'color': `var(--mui-palette-primary-contrastText)`,
      'backgroundColor': `var(--mui-palette-schemes-white-primary-main)`,
      'borderColor': `var(--mui-palette-schemes-${ownerState?.color}-primary-main) !important`,

      '&:hover': {
        border: '2px solid',
        borderColor: `var(--mui-palette-schemes-${ownerState?.color}-primary-main)`,
        backgroundColor: `var(--mui-palette-schemes-${ownerState?.color}-primary-main)`,
        color: `var(--mui-palette-schemes-${ownerState?.color}-primary-contrastText)`
      },

      '&:active': {
        backgroundColor: `var(--mui-palette-schemes-${ownerState?.color}-primary-lighter)`,
        color: `var(--mui-palette-primary-contrastText)`
      },

      '&.disabled': {
        backgroundColor: `var(--mui-palette-schemes-white-primary-main)`,
        color: `var(--mui-palette-schemes-navyBlue-primary-light)`,
        borderColor: `var(--mui-palette-schemes-navyBlue-primary-light)`
      }
    }),

    ...(ownerState?.variant?.includes('Text') && {
      'color': `var(--mui-palette-primary-contrastText)`,

      '&:hover': {
        color: `var(--mui-palette-schemes-black-primary-main)`
      },

      '&:active': {
        color: `var(--mui-palette-schemes-blue-primary-main)`
      },

      '&.disabled': {
        color: `var(--mui-palette-schemes-navyBlue-primary-light)`
      }
    }),

    ...(ownerState?.variant?.includes('Tag') && {
      'borderRadius': theme.spacing(0.5),
      'padding': theme.spacing(0.5, 1.5),
      'border': '0',
      'color': `var(--mui-palette-primary-contrastText)`,
      // 'backgroundColor': `var(--mui-palette-schemes-${ownerState?.color}-primary-lighter)`,
      'backgroundColor': `var(--mui-palette-schemes-blue-primary-lighter)`,

      '&:hover': {
        // backgroundColor: `var(--mui-palette-schemes-${ownerState?.color}-primary-light)`,
        backgroundColor: `var(--mui-palette-schemes-blue-primary-light)`,
        color: `var(--mui-palette-primary-contrastText)`
      },

      '&.disabled': {
        backgroundColor: `var(--mui-palette-schemes-white-primary-main)`,
        color: `var(--mui-palette-schemes-navyBlue-primary-light)`
      }
    }),

    ...(!!ownerState?.icon && !ownerState?.text
      ? {
          backgroundColor: 'transparent'
          // '&:hover': {
          //   backgroundColor: 'transparent'
          // }
        }
      : null)
  }),

  rootButton: {
    display: 'inline-flex',
    alignItems: 'center',
    boxShadow: 'none'
  },

  // rootLink: : {},

  // rootMuiLink: : {},

  // rootIconButton: : {},

  noLinkStyleIcon: ({ theme, iconPosition }) => ({
    margin: iconPosition === 'Left' ? `0 ${theme.spacing(1)} 0 0` : `0 0 0 ${theme.spacing(1)}`
  })
};

const createVariants = (_theme: Theme): ComponentsVariants['Link'] => [
  {
    props: {
      variant: 'link'
    },
    style: {
      // textDecoration: 'underline'
    }
  },
  {
    props: {
      variant: 'default'
    },
    style: {
      textDecoration: 'underline'
    }
  },
  {
    props: {
      variant: 'buttonText'
    },
    style: {
      // textDecoration: 'underline'
      // textTransform: 'unset'
    }
  }
];

export const LinkTheme = (theme: Theme): ThemeOptions => ({
  components: {
    Link: {
      defaultProps,

      styleOverrides,
      variants: createVariants(theme)
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'uppercase'
        }
      }
    }
  }
});

export default LinkTheme;
